import nth from 'lodash/nth'
import { useParams } from 'react-router-dom'

import FormatFilters from '@/gf/modules/FormatFilters'
import Money from '@/gf/modules/Money'
import ProductM from '@/gf/modules/Product'
import StoreOrderM from '@/gf/modules/StoreOrder'
import Time from '@/gf/modules/Time'
import useSearchStoreOrders from '../../hooks/useSearchStoreOrders'
import useSession from '../../hooks/useSession'

import StoreOrderStepBadge from '@/dealers/components/StoreOrderStepBadge'
import Card from '@/gf/components/Card'
import Link from '@/gf/components/LinkOld'
import Spinner from '@/gf/components/Spinner'

const LatestOrderCard = () => {
  const session = useSession()
  const orgId = (useParams<{ id: string }>() as { id: string }).id

  const storeOrdersResult = useSearchStoreOrders({
    variables: {
      page: 1,
      filters: FormatFilters.andFilters([
        ['equals', 'storeId', session.store.id],
        ['equals', 'organization_id', orgId],
      ]),
    },
    fetchPolicy: 'no-cache',
  })

  const storeOrders = storeOrdersResult.data?.storeOrdersSearch.storeOrders
  const storeOrder = nth(storeOrders, 0)

  return (
    <Card title="Latest Order">
      {storeOrder ? (
        <>
          <Card.Section>
            <div className="text-sm flex flex-col gap-2">
              <span className="flex">
                <span className="flex-1">
                  <Link to={`/orders/${storeOrder.id}`}>{storeOrder.shortId}</Link>
                </span>
                <span>{Time.toString(storeOrder.insertedAt)}</span>
              </span>
              <span className="flex">
                <span className="flex-1">
                  <StoreOrderStepBadge step={storeOrder.step} />
                </span>
                <span>
                  {Money.format(
                    [
                      StoreOrderM.subtotal(storeOrder),
                      storeOrder.shippingAmount,
                      ...storeOrder.additionalCharges.map((ac) => ac.price),
                    ].reduce(Money.add)
                  )}{' '}
                  total
                </span>
              </span>
            </div>
          </Card.Section>
          <Card.Section title={`Items (${storeOrder.lineItems.length})`}>
            {storeOrder.lineItems.map((lineItem) => (
              <Card.SubSection key={lineItem.id}>
                <div className="flex gap-4 text-sm">
                  <img
                    src={ProductM.primaryImageURL(lineItem.product, 'card')}
                    alt={lineItem.product.name}
                    className="w-16 h-16 border rounded-sm overflow-hidden"
                  />
                  <div className="flex flex-col flex-1">
                    <Link to={`/products/${lineItem.product.id}`}>{lineItem.product.name}</Link>
                    <span className="text-gray-500">MPN: {lineItem.product.mpn}</span>
                  </div>
                  <span>
                    {Money.format(lineItem.discountedUnitPrice)} x {lineItem.quantity}
                  </span>
                  <span>{Money.format(lineItem.extendedPrice)}</span>
                </div>
              </Card.SubSection>
            ))}
          </Card.Section>
        </>
      ) : (
        <>
          {storeOrdersResult?.loading && (
            <Card.Section>
              <Spinner />
            </Card.Section>
          )}
          {!storeOrdersResult?.loading && (
            <Card.Section>
              <div>No store orders</div>
            </Card.Section>
          )}
        </>
      )}
    </Card>
  )
}

export default LatestOrderCard
